import { PaginationResponse } from "../../../../model/base/response/pagination-response";
import { IListPublicationShipmentPagedRequest } from "../../../../model/publication-shipment/request/list-publication-shipment-paged-request";
import { IUpdatePublicationShipmentRequest } from "../../../../model/publication-shipment/request/update-publication-shipment-request";
import { IDetailPublicationShipmentResponse } from "../../../../model/publication-shipment/response/detail-publication-shipment-response";
import { IPublicationShipmentResponse } from "../../../../model/publication-shipment/response/publication-shipment-response";
import { IPublicationShipmentStatusResponse } from "../../../../model/publication-shipment/response/publication-shipment-status-response";
import { IUserSendPublicationShipmentResponse } from "../../../../model/publication-shipment/response/user-send-publication-shipment-response";


export type ConsultaRemessaState = {
  detailPublicationShipmentResponse?: IDetailPublicationShipmentResponse;
  listPublicationShipmentPagedRequest: IListPublicationShipmentPagedRequest;
  listPublicationShipmentResponse: PaginationResponse<IPublicationShipmentResponse>;
  isLoadingData: boolean;
  updatePublicationShipmentRequest: IUpdatePublicationShipmentRequest;
  listSatusPublicatioShipment: IPublicationShipmentStatusResponse[];
  listUsersSend: IUserSendPublicationShipmentResponse[]
};

export enum ACTION_TYPES {
  setListPublicationShipmentPagedRequest = 'setListPublicationShipmentPagedRequest',
  setUpdatePublicationShipmentRequest = 'setUpdatePublicationShipmentRequest',
  seListPublicationShipmentResponse = 'seListPublicationShipmentResponse',
  setIsLoadingData = 'setIsLoadingData',
  setListSatusPublicatioShipment = 'setListSatusPublicatioShipment',
  setListUsersSend = 'setListUsersSend',
  setDetailPublicationShipmentResponse = 'setDetailPublicationShipmentResponse',
}

export const ConsultaRemessaReducer = (state: ConsultaRemessaState, action: any): ConsultaRemessaState => {
  const { type, payload } = action;
  switch (type) {
    case ACTION_TYPES.setListPublicationShipmentPagedRequest:
      return {
        ...state,
        listPublicationShipmentPagedRequest: payload,
      };
    case ACTION_TYPES.setIsLoadingData:
      return {
        ...state,
        isLoadingData: payload,
      };
    case ACTION_TYPES.seListPublicationShipmentResponse:
      return {
        ...state,
        listPublicationShipmentResponse: payload,
      };
    case ACTION_TYPES.setListSatusPublicatioShipment:
      return {
        ...state,
        listSatusPublicatioShipment: payload,
      };
    case ACTION_TYPES.setListUsersSend:
      return {
        ...state,
        listUsersSend: payload,
      };
    case ACTION_TYPES.setDetailPublicationShipmentResponse:
      return {
        ...state,
        detailPublicationShipmentResponse: payload,
      };
    case ACTION_TYPES.setUpdatePublicationShipmentRequest:
      return {
        ...state,
        updatePublicationShipmentRequest: payload,
      };
    default:
      throw new Error(`Unhandled action type: ${type}`);
  }
}